import {connect} from 'react-redux';
import QCToolsArtworkContainer from './QCToolsArtworkContainer';
import {
    getQcToolsArtworkAction,
    resetQcToolsArtworkAction,
    setQcToolsArtworkDeliverableAction,
} from './Redux/QCToolsArtworkActions';
import {ArtworkItem} from './QCToolsArtworkTypes&Const';

export type QCToolsArtworkState = {
    qcTools: {
        qcToolsArtwork: {
            artworkImages: ArtworkItem[];
            isLoading: boolean;
        };
    };
};

export const mapState = (state: QCToolsArtworkState) => {
    const {qcTools} = state;
    const {
        qcToolsArtwork: {artworkImages, isLoading},
    } = qcTools;

    return {
        artworkImages,
        isLoading,
    };
};

const mapDispatch = {
    setQcArtwork: getQcToolsArtworkAction,
    resetQcArtwork: resetQcToolsArtworkAction,
    setDeliverable: setQcToolsArtworkDeliverableAction,
};

export default connect(mapState, mapDispatch)(QCToolsArtworkContainer);
